module.exports = __webpack_public_path__ + "img/improved-efficiencies.d77353a7.svg";